import { Button, Dialog, Grid, makeStyles, MenuItem, Switch, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOpenDeliveryAreaFormDialog, handleOpenDeliveryAreaFormDialog } from '../../reducers/uiSlice';
import UniDialog from '../Common/UniDialog';
import _ from 'lodash';
import {
    handleRowValues
} from "../../actions/deliveryAreaActions";
const useStyles = makeStyles((theme) => ({
    paramStyle: {
        marginTop: theme.spacing(2)
    },
    textFieldStyle: {
        width: 400
    },
    buttonGroupStyle: {
        textAlign: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
    buttonStyle: {
        width: 200
    }
}));

function CreateEditDialog(props) {
    const {t} = useTranslation('deliveryAreaManagement');
    const dispatch = useDispatch();
    const classes = useStyles();

    const openModalObject = useSelector(getOpenDeliveryAreaFormDialog);
    const rowValues = useSelector(state => state.deliveryAreaReducer.rowValues);

    const editZipCodeParams = [
        {
            label: t('zip_code'),
            type: 'text',
            disabled: openModalObject.type !== 'create',
            text: 'zipcode'
        },
        {
            label: t('sorting_zone'),
            type: 'text',
            disabled: false,
            text: 'sorting_zone'
        },
        {
            label: t('warehouse'),
            type: 'select',
            disabled: false,
            list: props.warehouses,
            text: 'city'
        },
        {
            label: t('airport'),
            type: 'text',
            disabled: false,
            text: 'owner'
        },
        {
            label: t('remote'),
            type: 'select',
            disabled: false,
            list: [
                {
                    id: '0',
                    text: t('No')
                },
                {
                    id: '1',
                    text: t('Yes')
                }
            ],
            text: 'is_remote'
        },
        {
            label: t('service_no'),
            type: 'text',
            disabled: false,
            text: 'route_no'
        },
        {
            label: t('price'),
            type: 'text',
            disabled: false,
            text: 'price'
        },
        {
            label: t('status'),
            type: 'switch',
            disabled: false,
            text: 'is_enabled'
        },
        {
            label: t('pattern_id'),
            type: 'text',
            disabled: openModalObject.type !== 'create',
            text: 'pattern_id'
        }
    ];
    const createNewZoneParams = [
        {
            label: t('name'),
            type: 'text',
            disabled: false,
            text: 'zone_name'
        },
        {
            label: t('zone_type'),
            type: 'select',
            disabled: false,
            list: props.zoneTypeList,
            text: 'zone_type'
        },
        {
            label: t('depart_airport'),
            type: 'select',
            disabled: false,
            list: props.airports,
            text: 'from_airport'
        },
        {
            label: t('destination_airport'),
            type: 'select',
            disabled: false,
            list: props.airports,
            text: 'to_airport'
        }
    ];

    const [params, setParams] = useState(editZipCodeParams);
    const [buttonName, setButtonName] = useState(t('save'));
    const [title, setTitle] = useState(t('edit_zip_code_info'));
    const [paramsForm, setParamsForm] = useState({});
    const [switchValue, setSwitchValue] = useState(true);
    const [zipCodeId, setZipCodeId] = useState('');

    const onClose = () => {
        dispatch(handleRowValues({}));
        dispatch(handleOpenDeliveryAreaFormDialog({open: false}))
    }
    const handleParamChange = (key, newValue, type) => {
        let _newValue = newValue
        if(type === 'switch') {
            _newValue = !newValue;
            setSwitchValue(_newValue);
        }
        setParamsForm(prevParamsForm => ({
            ...prevParamsForm,
            [key]: _newValue
        }));
    }

    useEffect(() => {
        if(openModalObject.id === 1) {
            setParams(editZipCodeParams);
            if(openModalObject.type === 'create') {
                setTitle(t('create_new_zipcode'));
                setButtonName(t('create_zipcode'));
            }else{
            setButtonName('save');
            setTitle(t('edit_zip_code_info'));
            }
        } else if(openModalObject.id === 2) {
            setParams(createNewZoneParams);
            if(openModalObject.type === 'create') {
                setTitle(t('create_new_zone'));
                setButtonName(t('create_zone'));
            } else {
                setTitle(t('edit_zone_information'));
                setButtonName(t('save'));
            }
            setZipCodeId('');
        }
        if(openModalObject.open) {
            setParamsForm([]);
        }
    }, [openModalObject])
    useEffect(() => {
        if(rowValues) {
            if(openModalObject.id === 1) {
                setZipCodeId(rowValues.id);
                setSwitchValue(rowValues.is_enabled);
                setParamsForm({
                    zipcode: rowValues.zipcode,
                    sorting_zone: rowValues.sorting_zone,
                    city: rowValues.city,
                    owner: rowValues.owner,
                    is_remote: rowValues.is_remote,
                    route_no: rowValues.route_no,
                    price: rowValues.price,
                    is_enabled: rowValues.is_enabled ? true : false,
                    pattern_id: rowValues.pattern_id
                })
            } else if(openModalObject.id === 2 && openModalObject.type === 'edit') {
                setParamsForm({
                    id: rowValues.id,
                    zone_name: rowValues.id,
                    zone_type: rowValues.zone_type,
                    from_airport: rowValues.from_airport?.substring(3),
                    to_airport: rowValues.to_airport?.substring(3)
                })
            }
            
        }
    }, [rowValues, openModalObject])

    return (
        <UniDialog
            open={openModalObject.open && openModalObject.id !== 0}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            disableDefaultButtons
            title={title}
        >
            <Grid container spacing={1}>
            {
                params?.length > 0 &&
                params.map((param, index) => (
                    param.type === 'text' ?
                    <Grid item xs={6} className={classes.paramStyle}>
                        <TextField
                            label={param.label}
                            disabled={param.disabled}
                            fullWidth
                            variant="outlined"
                            className={classes.textFieldStyle}
                            onChange={(e)=>handleParamChange(param.text, e.target.value)}
                            value={paramsForm[param.text]}
                        />
                    </Grid> :
                    (
                        param.type === 'select' ?
                        <Grid item xs={6} className={classes.paramStyle}>
                            <TextField
                                select
                                label={param.label}
                                disabled={param.disabled}
                                fullWidth
                                variant="outlined"
                                className={classes.textFieldStyle}
                                onChange={(e)=>handleParamChange(param.text, e.target.value)}
                                value={paramsForm[param.text]}
                            >
                            {
                                param.list?.length > 0 &&
                                param.list.map((item) => (
                                    <MenuItem
                                        value={item.id || item.airport_code} 
                                        key={`${item.name}`+index}
                                    >
                                        {item.name || item.text || item.airport_code}
                                    </MenuItem>
                                ))
                            }    
                            </TextField>
                        </Grid> :
                        <Grid item xs={6} className={classes.paramStyle}>
                            <span>{param.label}</span>
                            <Switch
                                disabled={param.disabled}
                                fullWidth
                                checked={switchValue}
                                onClick={(e)=>handleParamChange(param.text, switchValue, param.type)}
                            />
                            <span>
                            {
                                switchValue ?
                                t('active') :
                                t('inactive')
                            }
                            </span>
                        </Grid>
                    )
                ))
            }
            </Grid>
            <div className={classes.buttonGroupStyle}>
                <Button 
                    color='primary' 
                    variant='contained'
                    className={classes.buttonStyle}
                    onClick={()=>props.onSubmit(paramsForm, zipCodeId)}
                    disabled={!paramsForm['zone_name'] && !paramsForm['zipcode']}
                >
                    {buttonName}
                </Button>
            </div>
        </UniDialog>
    )
}

export default CreateEditDialog;